/** Primary in-game actions (tap, submit, start round). */
export const gamePrimaryButtonSx = {
  minHeight: 56,
  minWidth: { xs: "100%", sm: 220 },
  maxWidth: "100%",
  fontSize: "1.125rem",
  px: 2,
} as const;

/** Secondary actions (skip, cancel). */
export const gameSecondaryButtonSx = {
  minHeight: 56,
  minWidth: { xs: "100%", sm: 200 },
  maxWidth: "100%",
  fontSize: "1.125rem",
  px: 2,
} as const;

/** Idle / summary continue buttons (centered, not always full width). */
export const gameContinueButtonSx = {
  minHeight: 56,
  minWidth: { xs: "min(100%, 280px)", sm: 220 },
  fontSize: "1.125rem",
  alignSelf: "center",
} as const;
